export type CertificationDocument = {
  rawFile?: File;
  src?: string;
  title?: string;
};

export type DocumentAssignee = {
  id: string;
  label: string;
};

export type CertificateDocumentAnalysis = {
  lastReceivedOn: string | null;
  expiryDate: string | null;
};

export const hasCertificationDocument = (
  document: CertificationDocument | undefined,
): boolean => Boolean(document?.rawFile || document?.src);
